<template>
  <b-container>
    <div class="mt-4 d-flex justify-content-between">
      <back-arrow :bilan-type="bilanType"
                  :sub-title-ope="this.operationName"
                  :params="{operationId: operationId, currentSection:5, operationBilanId:operationBilanId}"
                  :title="$t('operation.bilan.Frais.financiers')"
                  route-back="OperationShow"/>

      <card-total-component
        :custom-class="`bilan-${(bilanType ? bilanType :  '').toLowerCase()}`"
        :value="prixHT | formatEuro"
        class="ml-auto col-md-2"
        title="operation.totalht"/>

      <card-total-component
        :custom-class="`bilan-${(bilanType ? bilanType :  '').toLowerCase()}`"
        :value="totalTVA | formatEuro"
        class="ml-2 col-md-2"
        title="operation.totaltva"/>

      <card-total-component
        :custom-class="`bilan-${(bilanType ? bilanType :  '').toLowerCase()}`"
        :value="totalTTC | formatEuro"
        class="ml-2 col-md-2"
        title="operation.totalttc"/>

    </div>

    <div class="row justify-content-between mt-3 mb-4">
      <div class="col-md-12">
        <div class="white-card mr-0 p-3">
          <div class="d-flex mb-0 align-items-center justify-content-end">
            <help-icon class="mr-2" size="18"/>
            <span>{{ $t('info.none.tva.frais') }}</span>
          </div>

          <b-form v-unsave-detector @submit.stop.prevent="onSubmit">

            <template v-for="operationCharge in operationCharges">
              <operation-charge-component
                :is-h-t="isHT"
                :operation-charge="operationCharge"
                @didChangeValue="emitChangeValue"
                @removedOperationCharge="removedOperationCharge"/>
            </template>

            <div class="row mt-3">
              <div class="col-md-12">
              <span class="bold-text addLink"
                    @click="addOperationCharge()"> + {{ $t('Add') }} {{ $t(typeFrais.text) }}</span>
              </div>
            </div>

            <div class="d-flex justify-content-end">
              <b-button type="submit" variant="primary">{{ $t('Save') }}</b-button>
            </div>

          </b-form>
        </div>
      </div>

      <add-operation-charge-modal
        :type-frais="typeFrais"
        :hide-percentage-modes="true"
        :is-h-t="isHT"
        @didAddOperationCharge="didAddOperationCharge"/>

    </div>
  </b-container>
</template>

<script>

import CardTotalComponent from "../../operation/components/CardTotalComponent.vue";
import BackArrow from "../../../components/b122/BackArrow.vue";
import OperationChargeComponent from "../components/OperationChargeComponent.vue";
import AddOperationChargeModal from "../components/AddOperationChargeModal.vue";
import api from "../../../services/api";

export default {
  name: "OperationBilanFraisFinanciersEdit",

  components: {
    CardTotalComponent,
    BackArrow,
    OperationChargeComponent,
    AddOperationChargeModal
  },

  data() {
    return {
      totalTTC: "-",
      totalTVA: "-",
      prixHT: "-",
      operationId: this.$route.params.operationId,
      operationBilanId: this.$route.params.operationBilanId,
      simulationId: this.$route.params.simulationId,
      operationCharges: [],
      operationChargesIdsToRemove: [],
      typeFrais: null,
      bilanType: null,
      operationName: null,
      isHT: false,
    }
  },

  emits: ['didFinish', 'didBack', 'didChangeValue'],

  async mounted() {
    await this.fetchData()
  },

  methods: {
    async fetchData() {
      await this.getOperation()
      await this.getOperationBilanId()
      await this.getOperationBilanType()
      await this.getTotalOfBilan()
      await this.getTypeFrais()
      await this.getOperationCharges()
    },

    async getOperation() {
      if (this.operationId != null) {
        await api
          .get(`/operation/${this.operationId}`)
          .then(response => {
            this.isHT = response.data.isHT
          })
      }
    },

    async getOperationBilanId() {
      await api
        .get(`/operation/getOperationBilanId/${this.operationId}`)
        .then(response => {
          this.operationBilanId = response.data.id
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 5,
                message: error.response.data.message
              }
            })
          }
        })
    },

    async getOperationBilanType() {
      this.isLoading = true
      api
        .get(`/operationBilan/getOperationBilanType/${this.operationBilanId}`)
        .then(response => {
          this.bilanType = response.data.bilanType
          this.operationName = response.data.operationName
        })
    },


    async getTypeFrais() {
      await api
        .get(`/operationCharge/getTypeOthers`)
        .then(response => {
          this.typeFrais = response.data
        })
    },

    async getTotalOfBilan() {
      await api
        .get(`/operationBilan/getTotalOfBilan/${this.operationId}`)
        .then(response => {
          this.totalTTC = response.data[4].prixTTC
          this.totalTVA = response.data[4].TVA
          this.prixHT = response.data[4].prixHT
        })
    },

    async getOperationCharges() {
      if (this.operationId != null) {
        await api
          .get(`/operationCharge/getAllOtherChargesForOperation/${this.operationId}`)
          .then(response => {
            this.operationCharges = response.data
            this.operationCharges.forEach(charge => {
              charge.prixTTC = charge.prixTTC.toFixed(2)
            })
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'OperationShow',
                params: {
                  operationId: this.operationId,
                  currentSection: 5,
                  message: error.response.data.message
                }
              })
            }
          })
      }
    },

    async emitChangeValue() {
      this.$emit('didChangeValue')
    },

    addOperationCharge() {
      this.$bvModal.show('add-operation-charge-modal')
    },

    didAddOperationCharge(operationCharge) {
      let operationChargeAdded = {...operationCharge, status: "added"}
      this.operationCharges.push(operationChargeAdded)
    },

    removedOperationCharge(operationCharge) {
      if (operationCharge.id) {
        this.operationChargesIdsToRemove.push(operationCharge.id)
      }
      this.operationCharges.splice(this.operationCharges.indexOf(operationCharge), 1)
    },

    back() {
      this.$confirm(this.$i18n.t('Back.confirm').toString()).then(() => {
        this.$emit('didBack')
      });
    },

    async onSubmit() {
      await this.createOrUpdateOperationCharges()
      await this.deleteOperationCharges()
      await this.editOperationBilan()
      await this.getTotalOfBilan()
      await this.generateMonthlyCharges()
      this.$router.push({
        name: 'OperationShow',
        params: {
          operationId: this.operationId,
          currentSection: 5
        }
      })
    },

    async createOrUpdateOperationCharges() {
      for (const operationCharge of this.operationCharges) {
        if (!operationCharge.bankCredit && operationCharge.typeFrais.value !== "INTERET_EMPRUNT") {
          let data = new FormData()
          data.append('operationId', this.operationId)
          data.append('name', operationCharge.name)
          data.append('prixTTC', operationCharge.prixTTC)
          data.append('typeFrais', operationCharge.typeFrais.value)

          let url = 'operationCharge'
          if (operationCharge.id) {
            url = '/operationCharge/' + operationCharge.id
          }

          await api({
            method: 'POST',
            url: url,
            data: data
          })
            .then(() => {
            })
            .catch((error) => {
              if (error.response.status === 401 || error.response.status === 404) {
                this.$router.push({
                  name: 'OperationShow',
                  params: {
                    operationId: this.operationId,
                    currentSection: 5,
                    message: error.response.data.message
                  }
                })
              }
            })
        }
      }
    },

    async deleteOperationCharges() {
      for (const operationChargeId of this.operationChargesIdsToRemove) {
        await api
          .delete(`/operationCharge/${operationChargeId}`)
      }
    },


    async editOperationBilan() {

      let data = new FormData()
      data.append('fraisFinanciersDone', true)

      api({
        method: 'POST',
        url: '/operationBilan/' + this.operationBilanId,
        data: data
      })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'SimulationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    async generateMonthlyCharges() {

      let data = new FormData()
      data.append('operationId', this.operationId)

      api({
        method: 'POST',
        url: '/treasury/generateMonthlyCharges',
        data: data
      })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 2,
                message: error.response.data.message
              }
            })
          }
        })
    },

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/operationBilan/bilanEditSteps/OperationBilanFraisFinanciersEdit.vue